var React = require('react');

function Alert12x12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.49678 0.51947C7.64739 0.606843 7.77257 0.732025 7.85994 0.882628L12.8583 9.49821C13.1354 9.97592 12.9728 10.5879 12.4951 10.865C12.3426 10.9534 12.1695 11 11.9933 11H1.99658C1.4443 11 0.996582 10.5523 0.996582 10C0.996582 9.82377 1.04316 9.65065 1.13161 9.4982L6.12999 0.882623C6.40714 0.404912 7.01907 0.242323 7.49678 0.51947ZM6.99998 7.75002C6.30962 7.75002 5.74998 8.30966 5.74998 9.00002C5.74998 9.69038 6.30962 10.25 6.99998 10.25C7.69033 10.25 8.24998 9.69038 8.24998 9.00002C8.24998 8.30966 7.69033 7.75002 6.99998 7.75002ZM5.99998 3.00002H7.99998V6.50002H5.99998V3.00002Z","fill":"currentColor"}));
}

Alert12x12.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = Alert12x12;

Alert12x12.default = Alert12x12;
